const PREFIX = '';
export default {
  // ip 收集
  POST_COLLECT_INFO_URL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/collect/info/create', data: data, params: params })
  },
  // LC-登录
  POST_AD_LOGIN(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/login', data: data, params: params })
  },
  // LC-微信登录
  POST_AD_WX_QRLOGIN(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/wxQrLogin', data: data, params: params })
  },
  // LC-获取当前登录用户信息
  POST_AD_FIND_LOGIN_USERINFO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/findLoginUserInfo', data: data, params: params })
  },
  // LC-获取当前登录品牌信息
  POST_AD_FIND_LOGIN_BRANDS(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/findUserBrands', data: data, params: params })
  },
  // LC-查询登录者资源信息
  POST_AD_FIND_LOGIN_USER_RESOURCES(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/findUserResources', data: data, params: params })
  },
  // LC-注销
  POST_AD_FIND_LOGOUT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/loginOut', data: data, params: params })
  },
  // LC-修改密码
  POST_MODIFY_PASSWORD(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/user/passwd/modify', data: data, params: params })
  },
  // 生产工艺单-分页查询
  POST_QUERY_TECHNICS_PRO_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/page', data: data, params: params })
  },
  // 生产工艺单-详情查询
  POST_TECHNICS_PRO_DETAIL_GET(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/detail/get', data: data, params: params })
  },
  // 生产工艺单-状态变更
  POST_TECHNICS_PRO_STATUS_UPDATE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/status/update', data: data, params: params })
  },
  // 生产工艺单-保存详情
  POST_TECHNICS_PRO_SAVE_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/detail/save', data: data, params: params })
  },
  //【工艺单档案】列表
  POST_TECH_RECORD_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/record/list', data: data, params: params })
  },
  //【工艺单档案】详情列表
  POST_TECH_RECORD_ITEM_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/record/item/list', data: data, params: params })
  },
  // 工艺单编码查询
  POST_PROTECHNICS_TARGET_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/code/list', data: data, params: params })
  },
  // 生产工艺单-导入工艺
  POST_PROTECHNICS_CPCRAFTDETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/cpCraft', data: data, params: params })
  },
  // 生产工艺单-获取最新面料详情
  PROTECHNICS_GETLASTFABRIC(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/last/fabric', data: data, params: params })
  },
  // 生产工艺单-获取最新需求数网格
  PROTECHNICS_GETLASTGRIDSIZE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/pro/technics/last/demand', data: data, params: params })
  },
  // 洗水唛-分页查询
  WASHLABEL_DATA_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/washLabel/page', data: data, params: params })
  },
  // 洗水唛-删除洗水唛信息
  POST_DELETE_WASHLABEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/washLabel/del', data: data, params: params })
  },
  // 洗水唛-excel导出
  POST_EXPORT_WASHLABEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/washLabel/export', data: data, params: params })
  },
  // 洗水唛-创建洗水唛信息
  POST_CREATE_WASHLABEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/washLabel/create', data: data, params: params })
  },
  // 洗水唛-修改洗水唛信息
  POST_UPDATE_WASHLABEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/washLabel/update', data: data, params: params })
  },
  // 洗水唛-详情查询
  POST_WASHLABEL_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/washLabel/view', data: data, params: params })
  },
  // 过单手册
  POST_BOM_COSTCHECK_MANUAL_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/project/cost/manual/list', data: data, params: params })
  },
  //吊牌数据列表
  POST_TAG_INFO_TAG_INFO_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/tagInfo/page', data: data, params: params })
  },
  //获取吊牌信息明细
  POST_TAG_INFO_GET_TAG_INFO_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/tagInfo/getDetail', data: data, params: params })
  },
  //修改吊牌信息
  POST_TAG_INFO_UPDATE_TAG_INFO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/tagInfo/update', data: data, params: params })
  },
  // 查询面辅料库存
  POST_INVENTORY_FIND(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/inventory/find', data: data, params: params })
  },
  //预制发票分摊单-查询分页列表
  POST_INVOICE_ALLOCATE_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/page', data: data, params: params })
  },
  //预制发票分摊单-删除单据
  POST_INVOICE_ALLOCATE_DELETE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/delete', data: data, params: params })
  },
  //预制发票分摊单-制单导出
  POST_INVOICE_ALLOCATE_SAVE_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/save/export', data: data, params: params })
  },
  //预制发票分摊单-确定
  POST_INVOICE_ALLOCATE_AUTO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/auto', data: data, params: params })
  },
  //预制发票分摊单-保存
  POST_INVOICE_ALLOCATE_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/save', data: data, params: params })
  },
  //预制发票分摊单-提交
  POST_INVOICE_ALLOCATE_SUBMIT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/submit', data: data, params: params })
  },
  // 预制发票分摊单-查询详情
  POST_INVOICE_ALLOCATE_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/detail', data: data, params: params })
  },
  //查询公司主体信息
  POST_COMPANY_FIND_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/company/findList', data: data, params: params })
  },
  //特征查询数据列表
  POST_MASTER_DATA_FEATURE_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/masterData/featurePage', data: data, params: params })
  },
  //特征新增颜色组/尺码组
  POST_MASTER_DATA_CREATE_FEATURE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/masterData/createFeature', data: data, params: params })
  },
  //特征修改颜色组/尺码组
  POST_MASTER_DATA_UPDATE_FEATURE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/masterData/updateFeature', data: data, params: params })
  },
  //特征停用/启用
  POST_MASTER_DATA_UPDATE_APPLY_STATUS(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/masterData/updateApplyStatus', data: data, params: params })
  },
  //获取颜色组/尺码组明细
  POST_SYS_GET_FEATURE_BY_ID(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/getFeatureById', data: data, params: params })
  },
  //特征值-查看修改记录用
  POST_MASTER_DATA_GET_APPLY_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/masterData/getApplyDetail', data: data, params: params })
  },
  //商品类目查询列表
  POST_SYS_MATERIAL_CATEGORY_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/materialCategoryPage', data: data, params: params })
  },
  // 商品分类-获取上级类别
  POST_SYS_GET_MATERIAL_CATEGORY_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/getMaterialCategoryList', data: data, params: params })
  },
  //商品类目查看修改记录用
  POST_SYS_GET_MATERIAL_CATEGORY_APPLY_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/getMaterialCategoryApplyDetail', data: data, params: params })
  },
  // 修改商品类目
  POST_SYS_UPDATE_MATERIAL_CATEGORY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/updateMaterialCategory', data: data, params: params })
  },
  POST_SYS_CREATE_MATERIAL_CATEGORY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/createMaterialCategory', data: data, params: params })
  },
  // 商品停用/启用
  POST_SYS_UPDATE_MATERIAL_CATEGORY_APPLY_STATUS(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/updateMaterialCategoryApplyStatus', data: data, params: params })
  },
  // 商品获取商品类目明细
  POST_SYS_GET_MATERIAL_CATEGORY_BY_ID(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/getMaterialCategoryById', data: data, params: params })
  },
  // 查询仓库信息
  POST_STORAGE_FIND_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/storage/findList', data: data, params: params })
  },
  //new分页查询cmt状态信息（cmt发料状态界面）
  POST_CMT_QUERY_CMT_INFO_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/queryCmtInfoPage', data: data, params: params })
  },
  //newCMT发料单-新建预留单
  POST_CMT_DEMANDS_ADD(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/demands/add', data: data, params: params })
  },
  //new 查询sap采购订单对应的预留需求信息（新建预留单界面）
  POST_CMT_DEMANDS_GET(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/demands/get', data: data, params: params })
  },
  //new CMT发料单-查询预留单信息
  POST_CMT_DEMANDS_FIND(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/demands/find', data: data, params: params })
  },
  //new CMT发料单-生管发料
  POST_CMT_SEND_CMT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/sendCmt', data: data, params: params })
  },
  //new CMT发料单-挂起申请
  POST_CMT_HANGUP(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/hangup', data: data, params: params })
  },
  //new CMT发料单-解挂申请
  POST_CMT_UNHANGUP(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/unHangup', data: data, params: params })
  },
  //new CMT发料单-取消
  POST_CMT_CANCEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/cancel', data: data, params: params })
  },
  //new CMT发料单-删除
  POST_CMT_DELETE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmt/delete', data: data, params: params })
  },
  //new CMT退料单-分页查询退料信息
  POST_CMT_BACK_QUERY_CMT_BACK_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtBack/queryCmtBackPage', data: data, params: params })
  },
  //new cmt退料单-查询退料数据[sap]
  POST_CMT_BACK_DEMANDS_GET(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtBack/demands/get', data: data, params: params })
  },
  //new cmt退料单-保存CMT退料单
  POST_CMT_BACK_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtBack/save', data: data, params: params })
  },
  //new cmt退料单-详情查询
  POST_CMT_BACK_DETAIL_GET(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtBack/detail/get', data: data, params: params })
  },
  //CMT调整单-分页查询
  POST_CMT_ADJUST_QUERY_CMT_ADJUST_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtAdjust/queryCmtAdjustPage', data: data, params: params })
  },
  //CMT调整单-查询组件消耗量
  POST_CMT_ADJUST_FIND_ADJUST_QTY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtAdjust/findAdjustQty', data: data, params: params })
  },
  //CMT调整单-保存调整单
  POST_CMT_ADJUST_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtAdjust/save', data: data, params: params })
  },
  //CMT调整单-删除
  POST_CMT_ADJUST_DELETE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtAdjust/delete', data: data, params: params })
  },
  //CMT调整单-过账提交
  POST_CMT_ADJUST_SUBMIT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtAdjust/submit', data: data, params: params })
  },
  //CMT调整单-详情查询
  POST_CMT_ADJUST_VIEW(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/cmtAdjust/view', data: data, params: params })
  },
  //退货质检查询列表
  POST_QUALITY_INSPECTION_SCMPAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/quality/inspection/scmPage', data: data, params: params })
  },
  //修改质检数据主表
  POST_QUALITY_INSPECTION_HEADER_UPDATE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/quality/inspection/header/update', data: data, params: params })
  },
  //退货质检导出
  POST_QUALITY_INSPECTION_SCMEXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/quality/inspection/scmExport', data: data, params: params })
  },
  //QC行程排单-QC行程排单列表
  POST_QCSCHEDULE_CHECK_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/qcScheling/checkList', data: data, params: params })
  },
  //获取成控看板
  POST_BOM_COST_VIEW_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/bom/cost/board', data: data, params: params })
  },
  //获取成控看图
  POST_BOM_COSTCHECK_VIEW_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/bom/cost/view', data: data, params: params })
  },
  //获取预控看图
  POST_PROJECT_COST_BOARD_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/project/cost/board', data: data, params: params })
  },
  // 批量删除评分表档案
  POST_SUPPLIER_CONFIG_BATHDEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/batchDelGradeConfig', data: data, params: params })
  },
  //保存评分表档案
  POST_SUPPLIER_SAVE_GRADECONFIG(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/saveGradeConfig', data: data, params: params })
  },
  //查询评分表档案详情
  POST_SUPPLIER_GET_GRADE_CONFIG_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getGradeConfigDetail', data: data, params: params })
  },
  //分页查询评分表档案
  POST_SUPPLIER_PAGEGRADECONFIG(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/pageGradeConfig', data: data, params: params })
  },
  POST_SUPPLIER_GRADERULE_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/pageGradeRule', data: data, params: params })
  },
  // 批量删除评分规则
  POST_SUPPLIER_RULE_BATHDEL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/batchDelGradeRule', data: data, params: params })
  },
  POST_SUPPLIER_GRADERULE_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/saveGradeRule', data: data, params: params })
  },
  POST_SUPPLIER_RULE_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getGradeRuleDetail', data: data, params: params })
  },
  //分页查询供应商准入列表
  POST_SUPPLIER_PAGESUPPLIERAPPLY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/pageSupplierApply', data: data, params: params })
  },
  //获取企业信息详情
  POST_SUPPLIER_GETSUPPLIERAPPLYDETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierApplyDetail', data: data, params: params })
  },
  //获取企业信息详情 辅料供应商
  POST_SUPPLIER_GET_V004_SUPPLIERAPPLYDETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierApplyConfigDetail', data: data, params: params })
  },
  //应商报价(基础信息填写)
  POST_SUPPLIER_SAVESUPPLIERAPPLY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/saveSupplierApply', data: data, params: params })
  },
  // 供应商准入 OA审核
  POST_SUPPLIER_AUDITOA(data, params) {
    return this.fetch({methods: 'post', url: PREFIX + '/app-lscm/supplier/auditOa', data: data, params: params})
  },
  // 供应商准入 新增临时供应商准入申请
  POST_SAVE_SUPPLIER_APPLY_TEMP(data, params) {
    return this.fetch({methods: 'post', url: PREFIX + '/app-lscm/supplier/saveSupplierApplyTemp', data: data, params: params})
  },
  // 供应商准入 退回供应商准入
  POST_BACK_SUPPLIER_APPLY_TEMP(data, params) {
    return this.fetch({methods: 'post', url: PREFIX + '/app-lscm/supplier/backSupplierApply', data: data, params: params})
  },

  // 获取用户名加密token
  SSO_GET_TOKEN(data, params) {
    return this.fetch({methods: 'get', url: PREFIX + '/app-lscm/sso/token/get', data: data, params: params})
  },


  //刷新天眼查消息

  POST_SUPPLIER_REFRESH_SUPPLIER_TYC_INFO(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/refreshSupplierTycInfo', data: data, params: params })

  },
  //获取供应商准入打印信息

  POST_SUPPLIER_GET_SUPPLIER_PRINT(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierPrint', data: data, params: params })

  },
  //获取供应商评分表详情

  POST_SUPPLIER_GETSUPPLIERGRADE(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierGrade', data: data, params: params })

  },
  //审核供应商准入

  POST_SUPPLIER_AUDITSUPPLIERAPPLY(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/auditSupplierApply', data: data, params: params })

  },
  //批量中止供应商准入单

  POST_SUPPLIER_BATCH_SUPPLIERAPPLY(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/batchSuspendSupplierApply', data: data, params: params })

  },
  //获取可用大类列表

  POST_SUPPLIER_GET_CONFIG_BIG_CLASS(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getConfigBigClass', data: data, params: params })

  },
  //企业信息填写

  POST_SUPPLIER_SAVE_SUPPLIER_APPLY_DETAIL(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/saveSupplierApplyDetail', data: data, params: params })

  },
  //企业信息填写 辅料供应商

  POST_SUPPLIER_SAVE_SUPPLIER_APPLY_V004_DETAIL(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/saveSupplierApplyConfigDetail', data: data, params: params })

  },
  //编辑供应商填报信息

  POST_SUPPLIER_EDIT_SUPPLIER_APPLY_DETAIL(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/editSupplierApplyDetail', data: data, params: params })

  },
  //提交供应商准入

  POST_SUPPLIER_SUBMIT_SUPPLIER_APPLY(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/submitSupplierApply', data: data, params: params })

  },
  //获取或刷新供应商token

  POST_SUPPLIER_GET_SUPPLIER_TOKEN(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierToken', data: data, params: params })

  },
  //分配现场评分人员

  POST_SUPPLIER_DISTRIBUTEGRADE(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/distributeGrade', data: data, params: params })

  },
  //批量删除供应商准入单

  POST_SUPPLIER_BATCH_DEL_SUPPLIER_APPLY(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/batchDelSupplierApply', data: data, params: params })

  },
  //查看审核情况

  POST_SUPPLIER_GET_SUPPLIER_APPLY_AUDIT(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierApplyAudit', data: data, params: params })

  },
  // 分页查询供应商资源池
  POST_SUPPLIER_PAGE_SUPPLIER_CONFIG(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/pageSupplierConfig', data: data, params: params })

  },
  // 分页查询供应商资源池
  POST_SUPPLIER_GET_SUPPLIER_CONFIG(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierConfig', data: data, params: params })

  },
  //保存供应商资源池
  POST_SUPPLIER_SAVE_SUPPLIER_CONFIG(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/saveSupplierConfig', data: data, params: params })

  },
  //获取天眼查消息
  POST_SUPPLIER_GET_SUPPLIER_TYCINFO(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/getSupplierTycInfo', data: data, params: params })

  },
  //天眼查公司列表
  POST_SUPPLIER_LIST_SUPPLIER_TYC_COMPANY_NAME(data, params) {

    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/listSupplierTycCompanyName', data: data, params: params })

  },
  POST_SUPPLIER_CONFIG(data, params) {
    return this.fetch({methods: 'post', url: PREFIX + '/app-lscm/supplier/listGradeConfigBySupplierId', data: data, params: params})
  },
  // 进度模型列表
  POST_AD_PNODE_MODEL_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/ad/pnode/model/list', data: data, params: params })
  },
  // 进度看板分页查询
  POST_AD_PNODE_TABLE_LIST(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/ad/pnode/table/page', data: data, params: params })
  },
  // 进度看板修改数据
  POST_AD_PNODE_TABLE_UPDATE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/ad/pnode/table/update', data: data, params: params })
  },
  // 进度看板修改数据
  POST_PROTECHNICS_GETUPDATELOG(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/data/log/findPage', data: data, params: params })
  },




  // 打印
  // 打印装箱单
  POST_SPSBOX_PRINTPACKINGINFO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/spsBox/printPackingInfo', data: data, params: params })
  },
  // 打印发货单所有装箱单
  POST_SPSBOX_PRINTPACKINGINFOALL_BYOUT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/spsBox/printPackageInfoAllByOut', data: data, params: params })
  },
  // 打印汇总单
  POST_SPSBOX_PRINTSUMMARY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/spsBox/printSummary', data: data, params: params })
  },
  // 打印所有贴箱单
  POST_SPSBOX_PRINTPACKINGINFOALL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/spsBox/printPackageInfoAll', data: data, params: params })
  },
  // 打印单个贴箱单
  POST_SPSBOX_PRINTPACKAGEINFO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/spsBox/printPackageInfo', data: data, params: params })
  },
  // 面料展厅打印二维码
  POST_PRINTDATA(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/spsBox/printPackageInfoAll', data: data, params: params })
  },
  //po打印
  POST_MRP_PO_PRINTING(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/mrp/po/printing', data: data, params: params })
  },
  //po M60 打印
  POST_MRP_PO_PRINT_SIXTY(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/mrp/po/print', data: data, params: params })
  },
  //【采购订单-面辅料】打印
  POST_PO_PM_MATERIAL_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/mrp/po/material/print', data: data, params: params })
  },
  // 获取bom详细(打印)
  POST_BOM_QUERY_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/mm/bom/getDetail', data: data, params: params })
  },
  // 采购收货查询-收货打印接口
  POST_MASTERIAL_RECEIPT_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/materialReceipt/getMaterialReceiptPrintById', data: data, params: params })
  },
  // 打印物流单号
  POST_SPSBOX_GETBOXPRINTING(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/package/sps/getBoxPrinting', data: data, params: params })
  },
  // 面料展厅打印
  POST_AD_MF_MASTERIAL_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/ad/mf/materialAttrPrintData', data: data, params: params })
  },
  //【扣款单-普通扣款】打印审核意见部分
  POST_DEBIT_GENERAL_ORDER_PRINTREMARK(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/debit/order/getGeneralOrderPrintRemark', data: data, params: params })
  },
  //【扣款单-普通扣款】打印详情
  POST_DEBIT_GENERAL_ORDER_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/supplier/debit/order/getGeneralOrderPrint', data: data, params: params })
  },
  // 面料开发核价打印
  POST_BPR_FABRIC_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/bpr/findBprFabricPage', data: data, params: params })
  },
  // 打样打印
  POST_Y_MATERIAL_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/material/findYMaterialPage', data: data, params: params })
  },
  // 查询面辅料详情信息
  POST_MATERIAL_INFO_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/material/findFabricInfo', data: data, params: params })
  },
  // 预制发票-打印
  POST_INVOICE_SCMPREINVOICEHEADER_GETPRINTDATA(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/invoice/preInvoiceHeader/getPrintData', data: data, params: params })
  },
  // 辅料报价查询打印接口
  ACCESSORY_QUOTED_ITEM_NORMAL_PRINT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/bpr/findBprAccessoryPrintInfoPage', data: data, params: params })
  },
  // 自评表打印接口
  EVALUATION_LOG_DETAIL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fob/getBprQuotedSelfEvaHeaderPrint', data: data, params: params })
  },
  // 获取面料供应商报价信息
  FABRIC_QUOTED_GET(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fabric/quoted/get', data: data, params: params })
  },



  //预付款-查询分页列表
  POST_ADVANCE_ORDER_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/page', data: data, params: params })
  },
  //预付款-更改OA状态
  POST_ADVANCE_ORDER_UPDATE_STATUS(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/updateStatus', data: data, params: params })
  },
  //预付款-导出
  POST_ADVANCE_ORDER_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/export', data: data, params: params })
  },
  //预付款-确定
  POST_ADVANCE_ORDER_AUTO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/auto', data: data, params: params })
  },
  //预付款-保存
  POST_ADVANCE_ORDER_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/save', data: data, params: params })
  },
  //预付款-提交OA
  POST_ADVANCE_ORDER_SUBMIT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/submit', data: data, params: params })
  },
  //预付款-查看详情
  POST_ADVANCE_ORDER_VIEW(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/advance/order/view', data: data, params: params })
  },
  //查询加工厂银行账号信息
  POST_VENDOR_FIND_BANK_INFO(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/vendor/findBankInfo', data: data, params: params })
  },

  // 常用功能保存
  POST_AD_LIKE_MENU_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/likeMenu/saveLikeMenu', data: data, params: params })
  },
  // 常用功能分页列表
  POST_AD_LIKE_MENU_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/likeMenu/page', data: data, params: params })
  },
  // 常用功能移出
  POST_AD_LIKE_MENU_REMOVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-scm-plugin/ad/likeMenu/removeLikeMenu', data: data, params: params })
  },
  // 批量创建面-辅料打样进度节点
  POST_AD_PNODEINSTANCE_BATCHCREATE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/ad/mf/pnodeInstance/batchCreate', data: data, params: params })
  },




  // 外部报表
  //s4财务报表明细导出
  POST_FICO_SETTLE_DATA_EXPORT_ITEM(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fico/settleDataExport/item', data: data, params: params })
  },
  //s4财务报表明细汇总
  POST_FICO_SETTLE_DATA_EXPORT_SUM(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fico/settleDataExport/sum', data: data, params: params })
  },
  //应付账款报表-汇总导出
  POST_FICO_ACCOUNT_PAY_ABLE_SUM_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fico/accountPayAble/sum/export', data: data, params: params })
  },
  //应付账款报表-明细导出
  POST_FICO_ACCOUNT_PAY_ABLE_ITEM_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fico/accountPayAble/item/export', data: data, params: params })
  },
  //采购系统发票接口
  POST_PO_CPI_INVOICE_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/po/cpi/invoice/export', data: data, params: params })
  },
  //预制发票分摊单-导出
  POST_INVOICE_ALLOCATE_EXPORT(data, params) {
    return this.fetch({methods: 'post', url: PREFIX + '/app-lscm/invoice/allocate/export', data: data, params: params})
  },
  //采购收货信息接口
  POST_PO_CPI_RECEIVE_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/po/cpi/receive/export', data: data, params: params })
  },
  //货币转换汇率  报表下载
  POST_FICO_CURRY_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/fico/curry/export', data: data, params: params })
  },
  //面辅料出仓明细报表
  SCM_FABRIC_OUTITEM_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/s4/fabric/outItem/export', data: data, params: params })
  },
  //订货板及船样板报表导出
  SCM_ORDER_AND_SHIP_EXPORT(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/s4/orderAndShip/export', data: data, params: params })
  },
  // 总Q未检列表
  APPOINTMENT_INSPECTION_PAGE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/appointment/inspection/page', data: data, params: params })
  },
  // 总Q质检
  APPOINTMENT_INSPECTION_SAVE(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/appointment/inspection/save', data: data, params: params })
  },
  POST_APPOINTMENT_QUALITY_INSPECTION_VIEW(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/appointment/qualityInspection', data: data, params: params })
  },
  // 总Q送广检
  POST_APPOINTMENT_SYNC_QUALITY_INSPECTION(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/appointment/syncQualityInspection', data: data, params: params })
  },
}